@if (showTableTop) {
    <pcg-table-top
        #tableTop
        [table]="this"
        [canGlobalSearch]="canGlobalSearch"
        [pageSizeSource]="pageSizeSource"
        [filterSource]="filterSource"
        [pageLengths]="pageLengths"
        [exactMatchSource]="exactMatchSource"
        [columnDefs]="columnDefs"
        [filterId]="filterId"
        [filters]="filterId ? ajaxData : null"
        [ajaxData]="ajaxData"
        [canResetFilters]="canResetFilters"
        [filterMap]="filterMap"
        [canExportTableToExcel]="canExportTableToExcel"
        [canPrintTable]="canPrintTable"
        [hasTooltips]="hasTooltips"
        [tooltipContent]="tooltipContent"
        [canShowHideColumns]="canShowHideColumns"
    ></pcg-table-top>
}

<tr class="search-row" *matHeaderRowDef="getColHeaderDefs()" mat-header-row></tr>
<tr class="footer-row" *matFooterRowDef="getVisibleColDefs()" mat-footer-row></tr>

<!-- Desktop Table -->
<div
    role="region"
    aria-label="Table"
    #tableContainer
    [class.pcg-table-responsive]="isResponsive"
    [class.pcg-table-fixed-footer]="fixedFooter"
    [class.pcg-table-fixed-header]="fixedHeader"
    class="pcg-table-container mb-1"
>
    <!-- The table -->
    <table [dataSource]="dataOnPageSource" mat-table class="data-grid" [class]="'pcg-table-' + tableNum">
        <!-- Displayed if no records are in the table -->
        <ng-container matColumnDef="noRecords">
            <td colspan="999" mat-cell *matCellDef="let row">
                @if (hasCompletedServerRequest || !serverSide) {
                    <div>No records to display</div>
                }
                @if (!hasCompletedServerRequest && serverSide) {
                    <div>Loading...</div>
                }
            </td>
        </ng-container>

        <!-- Optional per column search -->
        @for (col of getColDefs(); track col; let i = $index) {
            <ng-container [matColumnDef]="col + '_search'">
                <th [class]="getColSearchClasses(col)" mat-header-cell *matHeaderCellDef="let row">
                    @if (canSearch(col) && isNdc(col)) {
                        <input
                            [value]="perColumnSearchSource.value[i]"
                            (keyup)="updatePerColumnSearch(i, $event.target.value)"
                            [attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
                            placeholder="Search..."
                            class="form-control form-control-sm hide-on-print"
                            mask="00000-0000-00"
                            type="search"
                        />
                    }
                    @if (canSearch(col) && !isNdc(col)) {
                        <input
                            [value]="perColumnSearchSource.value[i]"
                            (keyup)="updatePerColumnSearch(i, $event.target.value)"
                            [attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
                            placeholder="Search..."
                            class="form-control form-control-sm hide-on-print"
                            type="search"
                        />
                    }
                </th>
            </ng-container>
        }

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="getVisibleColDefs()"></tr>
        <tr
            mat-row
            *matRowDef="let row; when: hasData; columns: getVisibleColDefs()"
            (click)="emitClick(row)"
            [class]="isRowClickable === true ? 'clickable-row' : ''"
        ></tr>
        <tr mat-row *matRowDef="let row; when: hasNoData; columns: ['noRecords']"></tr>
    </table>
</div>

<!-- Pagination footer -->
@if (showNumRows) {
    <div class="d-flex-table align-items-start">
        <div class="bottom-left-container filter-count-container form-inline hide-on-print">
            <div class="d-flex-table align-items-start">
                <span class="sm">Show</span>
                <select
                    (change)="pageSizeSource.next($event.target.value)"
                    [class]="
                        pageSizeSource.value < 1000
                            ? 'form-control form-control-sm pageSize mx-sm-1 ml-1'
                            : 'form-control form-control-sm mx-sm-1 ml-1'
                    "
                >
                    @for (length of pageLengths; track length) {
                        <option aria-label="Table page length" [selected]="pageSizeSource.value === length">
                            {{ length }}
                        </option>
                    }
                </select>
            </div>
        </div>
        @if (showPagination) {
            <div class="w-100 mb-2 clearfix">
                <div role="status" aria-live="polite" class="filter-count-container">
                    Showing
                    {{
                        filteredDataCount === 0
                            ? 0
                            : ((currentPageSource.value - 1) * pageSizeSource.value + 1 | number)
                    }}
                    to
                    {{
                        (filteredDataCount < currentPageSource.value * pageSizeSource.value
                            ? filteredDataCount
                            : currentPageSource.value * pageSizeSource.value
                        ) | number
                    }}
                    of
                    {{ filteredDataCount | number }}
                    entries
                    @if (filteredDataCount !== totalDataCount) {
                        <span>(filtered from {{ totalDataCount | number }} total entries)</span>
                    }
                </div>

                <!-- Page switcher -->
                <div class="pagination-container hide-on-print">
                    <ngb-pagination
                        role="navigation"
                        aria-label="Table paging"
                        [collectionSize]="filteredDataCount"
                        [pageSize]="pageSizeSource.value"
                        [page]="currentPageSource.value"
                        (pageChange)="currentPageSource.next($event)"
                        [maxSize]="5"
                        [rotate]="true"
                    ></ngb-pagination>
                </div>
            </div>
        }
    </div>
}
